<template>
  <v-dialog v-model="dialog" persistent max-width="1000">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        :color="color"
        class="ml-3"
      >
        <v-icon>{{ icon }}</v-icon><span v-if="edit === false">Adicionar</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <br><br>
        <v-row>
          <v-col sm="3">
            <v-text-field
                label="Item"
                name="item"
                type="text"
                required
                v-model="payload.item"
            ></v-text-field>

          </v-col>
          <v-col sm="3">
            <v-text-field
                label="Tempo"
                name="tempo"
                type="number"
                required
                v-model="payload.tempo"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              v-model="payload.data"
              v-mask="'##/##/####'"
              label="Data"
              placeholder="00/00/0000"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SalaTempoAPI } from '../API/SalaTempo'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'AppModalInsertUr',
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  components: {},
  data () {
    return {
      payload: [
        {
          item: '',
          custo: '',
          data: ''
        }
      ],
      dialog: false,
      Id: 0
    }
  },
  mounted () {
    if (this.object && this.edit === true) {
      this.payload = this.object
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    onConfirm () {
      if (this.edit === true) {
        let formData = new FormData()
        formData.append('salaTempoId', this.payload.salaTempoId)
        formData.append('item', this.payload.item)
        formData.append('tempo', this.payload.tempo)
        formData.append('data', moment(this.payload.data, 'DD/MM/YYYY').toISOString())
        formData.append('Municipioid', this.$route.params.id)

        SalaTempoAPI
          .update(formData)
          .then((resp) => {
            this.dialog = false
            location.reload()
          })
          .catch()
      } else {
        let formData = new FormData()

        formData.append('item', this.payload.item)
        formData.append('tempo', this.payload.tempo)
        formData.append('data', moment(this.payload.data, 'DD/MM/YYYY HH:ss').toISOString())
        formData.append('Municipioid', this.$route.params.id)

        SalaTempoAPI
          .create(formData)
          .then((resp) => {
            this.dialog = false
            location.reload()
          })
          .catch()
      }
    }
  }
}
</script>
